import { ADJUSTER_REPORT_CULPRIT_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import ContactCulpritInformation from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/driver/ContactCulpritInformation';
import CulpritCertificateInformation from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/driver/CulpritCertificateInformation';
import InitialCulpritDriverInfo from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/driver/InitialCulpritDriverInfo';
import InitialOwnerForm from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/owner/InitialOwnerForm';
import InsuranceInformationWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/propertyInsurance/editPropertyInsurance/EditPropertyInsurance';
import ShowInsuranceInformationWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/propertyInsurance/showPropertyInsurance/ShowPropertyInsurance';
import CulpritVehicleInformationPartOne from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/partOne/PartOne';
import VehicleInformationPartTwoWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/partTwo/PartTwo';
import ShowVehicleInformationWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/showVehicleInformation/ShowVehicleInformation';
import CulpritInformationTabsPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/CulpritInformationTabsPage';
import CulpritDriverInfo from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/driver-owner/culpritDriverInfo/CulpritDriverInfo';
import ContactOwnerForm from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/driver-owner/culpritOwnerInfo/ContactOwnerForm';
import CulpritOwnerInfo from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/driver-owner/culpritOwnerInfo/CulpritOwnerInfo';
import ShowCulpritInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/driver-owner/showCulpritInformation/showCulpritInformation';
import PropertyCulpritInsurance from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/property-insurance/PropertCulpritInsurance';
import VehicleCulpritInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/vehicleInformation/VehicleCulpritInformation';
import { PropertyInsuranceEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/PropertyInsurance.type';
import { VehicleInformationEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/VehicleInformationType';
import { Outlet, RouteObject } from 'react-router-dom';

export const CULPRIT_VEHICLE_INFORMATION_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.VEHICLE_INFORMATION.EDIT
      .base,
    element: (
      <VehicleCulpritInformation>
        <Outlet />
      </VehicleCulpritInformation>
    ),

    children: [
      {
        element: (
          <CulpritVehicleInformationPartOne
            type={VehicleInformationEnum.culprit}
          />
        ),
        index: true,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.VEHICLE_INFORMATION.EDIT
          .partTwo,
        element: (
          <VehicleInformationPartTwoWrapper
            type={VehicleInformationEnum.culprit}
          />
        ),
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.VEHICLE_INFORMATION.show,
    element: (
      <ShowVehicleInformationWrapper type={VehicleInformationEnum.culprit} />
    ),
  },
];

export const CULPRIT_INSURANCE_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.INSURANCE.edit,
    element: (
      <PropertyCulpritInsurance>
        <Outlet />
      </PropertyCulpritInsurance>
    ),

    children: [
      {
        element: (
          <InsuranceInformationWrapper type={PropertyInsuranceEnum.culprit} />
        ),
        index: true,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.INSURANCE.show,
        element: (
          <ShowInsuranceInformationWrapper
            type={PropertyInsuranceEnum.culprit}
          />
        ),
      },
    ],
  },
];

export const CULPRIT_DRIVER_OWNER_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.DRIVER_OWNER.EDIT.base,
    element: (
      <CulpritDriverInfo>
        <Outlet />
      </CulpritDriverInfo>
    ),
    children: [
      {
        element: <InitialCulpritDriverInfo />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.DRIVER_OWNER.EDIT
          .certificate,
        element: <CulpritCertificateInformation />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.DRIVER_OWNER.EDIT
          .driverContact,
        element: <ContactCulpritInformation />,
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.DRIVER_OWNER.EDIT.owner,
    element: (
      <CulpritOwnerInfo>
        <Outlet />
      </CulpritOwnerInfo>
    ),
    children: [
      {
        index: true,
        element: <InitialOwnerForm />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.DRIVER_OWNER.EDIT
          .ownerContact,
        element: <ContactOwnerForm />,
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.DRIVER_OWNER.show,
    element: <ShowCulpritInformation />,
  },
];

export const ADJUSTER_REPORT_CULPRIT_INFORMATION_ROUTES: RouteObject[] = [
  {
    children: [
      { index: true, element: <CulpritInformationTabsPage /> },
      ...CULPRIT_VEHICLE_INFORMATION_ROUTES,
      ...CULPRIT_INSURANCE_ROUTES,
      ...CULPRIT_DRIVER_OWNER_ROUTES,
    ],
  },
];
